/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IEnrichedChatSchema } from '../../entities/enriched_chat/EnrichedChatSchema';
import { IGetAgentStatsResponseSchema } from '../../entities/get_agent_stats_response/GetAgentStatsResponseSchema';
import { IContentPartSchema } from '../../entities/entities/ContentPartSchema';
import { IDegradationsSchema } from '../../entities/entities/DegradationsSchema';
import { ILinksSchema } from '../../entities/entities/LinksSchema';
import { IVacancyWithCompanyPagingListSchema } from '../../entities/vacancy_with_company_paging_list/VacancyWithCompanyPagingListSchema';

export type TGetAgentInfoModel = IModel<IGetAgentInfoRequest, TGetAgentInfoResponse>;

export interface IGetAgentInfoRequest {
  /** Тип аккаунта **/
  accountType?: EAccountType | null;
  /** Id пользователя, который осуществляет запрос **/
  userId?: number | null;
  /** Циан ID пользователя **/
  id?: number | null;
}

export type TGetAgentInfoResponse = IGetAgentInfoResponse200 | IGetAgentInfoResponse400;

export interface IGetAgentInfoResponse200 extends IModelResponse<IGetAgentInfoResponse> {
  statusCode: 200;
}

export interface IGetAgentInfoResponse400 extends IModelResponse<IGetAgentInfoResponseError> {
  statusCode: 400;
}

export interface IGetAgentInfoResponse {
  /** Данные агента **/
  agent: any;
  /** Чат с агентом **/
  chat?: IEnrichedChatSchema | null;
  /** Статистика по чатам **/
  chatsStatistics?: IGetAgentStatsResponseSchema | null;
  /** Информация из контентного раздела **/
  contentPart: IContentPartSchema;
  /** Флаги деградаций **/
  degradations: IDegradationsSchema;
  /** Ссылки **/
  links: ILinksSchema;
  /** Группы объявлений по типу недвижимости и типу сделки **/
  offers?: any[] | null;
  /** Отзывы об агенте **/
  reviews?: any | null;
  /** Вакансии **/
  vacancies?: IVacancyWithCompanyPagingListSchema | null;
}

export interface IGetAgentInfoResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IGetAgentInfoResponse | IGetAgentInfoResponseError;

export enum EAccountType {
  /** 
        Выпилить в CD-115192 после исправления бага в приложении + 12 месяцев, то есть примерно в июне 2022 года.
        https://cianru.slack.com/archives/CMC7RAT5E/p1618423300010300?thread_ts=1618421338.001700&cid=CMC7RAT5E
        https://jira.cian.tech/browse/ANDROID-14822
     **/
  SPECIALIST = 'SPECIALIST',
  /** Агентство **/
  Agency = 'agency',
  /** Специалист **/
  Specialist = 'specialist',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetAgentInfoResponse): TResponse200;
  400(response: IGetAgentInfoResponseError): TResponse400;
}
